import { createSlice } from '@reduxjs/toolkit';

import { AppError } from 'entities/Errors';
import { PlantApi } from 'entities/PlantApi';

import * as action from './plant_api.action';

interface State {
  action: 'idle' | 'list' | 'get';
  state: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: AppError | null;
  list: PlantApi[];
  plantApi: PlantApi | null;
}

const initialState = {
  action: 'idle',
  state: 'idle',
  error: null,
  list: [],
  plantApi: null,
} as State;

export const PlantApiSlice = createSlice({
  name: 'plantApi',
  initialState,
  reducers: {
    refresh: (state) => {
      state.action = 'idle';
      state.state = 'idle';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(action.getPlantApiList.pending, (state) => {
        state.state = 'loading';
        state.action = 'list';
        state.list = [];
        state.error = null;
      })
      .addCase(action.getPlantApiList.fulfilled, (state, action) => {
        state.state = 'succeeded';
        state.list = action.payload.data;
      })
      .addCase(action.getPlantApiList.rejected, (state, action) => {
        state.state = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(action.getPlantApi.pending, (state) => {
        state.state = 'loading';
        state.action = 'get';
        state.plantApi = null;
        state.error = null;
      })
      .addCase(action.getPlantApi.fulfilled, (state, action) => {
        state.state = 'succeeded';
        state.plantApi = action.payload.data;
      })
      .addCase(action.getPlantApi.rejected, (state, action) => {
        state.state = 'failed';
        state.error = action.payload as AppError;
      });
  },
});

export const { refresh: plantApiRefresh } = PlantApiSlice.actions;

export default PlantApiSlice.reducer;
